module.exports = __webpack_public_path__ + "static/media/allCards.3c309f53.svg";